<template>
  <div style="" class="box">
    <div class="page-item">
      <OfficialWebsiteHomePage
        :qrCode="data?.qrCode"
        :isLargeWindow="isLargeWindow"
      />
    </div>
    <div class="page-item">
      <OfficialWebsiteEditorPage
        :functionConfig="data?.functionConfig"
        :isActive="isInViewport.items[1]"
        :isLargeWindow="isLargeWindow"
      />
    </div>
    <div class="page-item" ref="templatePageRef">
      <OfficialWebsiteTemplatePage
        :templateConfig="data?.templateConfig"
        :isActive="isInViewport.items[2]"
        :isLargeWindow="isLargeWindow"
      />
    </div>
    <div class="page-item">
      <OfficialWebsiteAIAnimatePage
        :AIAnimateConfig="data?.AIAnimateConfig"
        :isActive="isInViewport.items[3]"
        :isLargeWindow="isLargeWindow"
      />
    </div>
    <div class="page-item">
      <OfficialWebsiteAICreatorPage
        :AICreatorConfig="data?.AICreatorConfig"
        :isActive="isInViewport.items[4]"
        :isLargeWindow="isLargeWindow"
      />
    </div>
    <div class="page-item">
      <OfficialWebsiteCreatorCenterPage
        :creatorCenterConfig="data?.creatorCenterConfig"
        :isActive="isInViewport.items[5]"
        :isLargeWindow="isLargeWindow"
      />
    </div>
    <div class="page-item">
      <OfficialWebsiteMaterialPage
        :materialConfig="data?.materialConfig"
        :isActive="isInViewport.items[6]"
        :isLargeWindow="isLargeWindow"
      />
    </div>
    <!-- <div class="page-item">
      <MaterialPage
        :materialConfig="data?.materialConfig"
        :isActive="isInViewport.items[6]"
        :isLargeWindow="isLargeWindow"
        v-if="isInViewport.items[6]"
      />
    </div> -->
    <!-- <div v-if="isInViewport.items[6]">
      <Footer :footer-config="data?.footerConfig" />
    </div> -->
    <div v-if="isLargeWindow">
      <OfficialWebsiteFooter :footer-config="data?.footerConfig" />
    </div>
  </div>
</template>

<script setup lang="ts">
import projectLogger from "@/utils/project-log";
import kylogger from "@ky/sdk/dist/log/kylogger";
import { WebpMachine } from "webp-hero";
import "@/assets/css/animate.css";
if (process.client) {
  var webpMachine = new WebpMachine();
  webpMachine.polyfillDocument();
}
// const EditorPage = defineAsyncComponent(
//   () => import('@/components/officialWebsite/EditorPage.vue')
// )
// const TemplatePage = defineAsyncComponent(
//   () => import('@/components/officialWebsite/TemplatePage.vue')
// )
// const AIAnimatePage = defineAsyncComponent(
//   () => import('@/components/officialWebsite/AIAnimatePage.vue')
// )
// const AICreatorPage = defineAsyncComponent(
//   () => import('@/components/officialWebsite/AICreatorPage.vue')
// )
// const CreatorCenterPage = defineAsyncComponent(
//   () => import('@/components/officialWebsite/CreatorCenterPage.vue')
// )
// const MaterialPage = defineAsyncComponent(
//   () => import('@/components/officialWebsite/MaterialPage.vue')
// )
// const Footer = defineAsyncComponent(
//   () => import('@/components/officialWebsite/Footer.vue')
// )
useSeoMeta({
  title: "快影-专业简单好用的视频剪辑软件-快手官方视频剪辑神器",
  keywords:
    "快影,快影官网,快影APP,快影下载,快影官方下载,快影APP免费下载,快影移动端APP,快影APP下载,快影APP官方下载,快影安卓,快影苹果,快影android,快影iOS,视频剪辑、视频编辑器、视频制作、音频、字幕、特效、AI、AI创作",
  description:
    "快影是一款强大而易于使用的视频剪辑软件，它提供各种工具和特效帮助您快速制作专业的视频，一键分享快手。快影官网为您提供快影APP免费下载服务，移动端包含安卓版(Android)与苹果版(iOS)，快来体验吧！",
});
useHead({
  script: [{ src: "/js/pc-flexible.js", type: "text/javascript" }],
});
const { data } = await useAsyncData(async (params) => {
  const route = useRoute();
  const config = useRuntimeConfig();
  const host = config.public.VITE_KY_API_HOST;
  const res = await $fetch(
    `${host}/rest/n/kmovie/app/config/getAppSwitch?${crypto(true)}`,
  );
  const switches = res?.switches.kmovieOfficialWebsiteFunctionIconList?.value;
  // console.log('===switches', switches.AIAnimateConfig)
  return {
    qrCode: switches.downloadQr,
    functionConfig: switches.functionConfig,
    templateConfig: switches.templateConfig,
    AIAnimateConfig: switches.AIAnimateConfig,
    AICreatorConfig: switches.AICreatorConfig,
    creatorCenterConfig: switches.creatorCenterConfig,
    materialConfig: switches.materialConfig,
    footerConfig: switches.footerConfig,
  };
});
const isInViewport = reactive({
  items: [false, false, false, false, false, false, false],
});
const hasLog = ref([false, false, false, false, false, false, false]);
const elementRef = ref(null);
const templatePageRef = ref(null);
const isLargeWindow = ref(true);

function checkIsInView(pageItems: HTMLCollectionOf<Element>) {
  Array.from(pageItems).forEach((element, index) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isInViewport.items[index] = true;
            if (!hasLog.value[index]) {
              kylogger.collect("SHOW", "PAGE_NUM", {
                page: index + "",
              });
              hasLog.value[index] = true;
            }
            observer.unobserve(element);
          }
        });
      },
      {
        rootMargin: "-10px",
      },
    );
    if (element) {
      observer.observe(element);
    }
  });
}
function checkWindowSize() {
  isLargeWindow.value = window.innerWidth > 768;
}
onMounted(() => {
  const pageItems = document.getElementsByClassName("page-item");
  checkIsInView(pageItems);
  checkWindowSize();
  kylogger.collect("PV", "HOMEPAGE");
  window.addEventListener("resize", checkWindowSize);
  nextTick(() => {
    projectLogger.plugins.radar?.fmp(Date.now());
  });
});
onUnmounted(() => {
  window.removeEventListener("resize", checkWindowSize);
});
</script>

<style scoped>
.box {
  height: 100vh;
  min-height: 760px;
}
.page-item {
  height: 100%;
  min-height: 760px;
}
</style>
